import { useState } from 'react'

import { GridRowColumn } from '@/componentsV1/BaseComponents'
import { Alert, Button, Dialog, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { getFetchError, getIsFetching } from '@/reducers/fetch'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'

import {
  RESYNC_TAXFYLE_DOCUMENTS_FETCH_KEY,
  resyncTaxfyleDocumentsForFilingForm,
} from './adminAnnualTaxFilings.slice'

const ResyncTaxfyleDocumentsButton = ({
  filingFormId,
  taxfyleJobId,
}: {
  filingFormId: number
  taxfyleJobId: string
}) => {
  const dispatch = useAppDispatch()
  const fetchKey = RESYNC_TAXFYLE_DOCUMENTS_FETCH_KEY(filingFormId)
  const isResyncing = useReselector(getIsFetching, fetchKey)
  const resyncError = useReselector(getFetchError, fetchKey)

  const [confirmOpen, setConfirmOpen] = useState(false)

  const handleConfirm = async () => {
    await resyncTaxfyleDocumentsForFilingForm(filingFormId)(dispatch)
    setConfirmOpen(false)
  }

  return (
    <>
      <GridRowColumn short>
        <Button
          variant="link"
          onClick={() => setConfirmOpen(true)}
          disabled={isResyncing}
        >
          {isResyncing ? 'Re-syncing…' : 'Re-Sync Documents'}
        </Button>
      </GridRowColumn>
      {resyncError?.message && (
        <GridRowColumn short>
          <Alert variant="error" description={resyncError.message} />
        </GridRowColumn>
      )}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onOpenChange={setConfirmOpen}
      >
        <Dialog.Content size="sm" onDismiss={() => setConfirmOpen(false)}>
          <Dialog.Title>Re-Sync Documents</Dialog.Title>
          <Dialog.Description>
            <Text variant={TypographyStyles.BODY_MD}>
              Re-push all of this user&rsquo;s eligible documents to Taxfyle job{' '}
              {taxfyleJobId}? Re-sync runs in the background.
            </Text>
          </Dialog.Description>
          <Dialog.Footer>
            <Button
              variant="secondary"
              onClick={() => setConfirmOpen(false)}
              disabled={isResyncing}
            >
              Cancel
            </Button>
            <Button onClick={handleConfirm} disabled={isResyncing}>
              {isResyncing ? 'Starting…' : 'Re-Sync'}
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog>
    </>
  )
}

export default ResyncTaxfyleDocumentsButton
